import {
  FLIGHT_BOOKING,
  FLIGHT_FARE_CONFIRMATION,
  FLIGHT_MAKE_PAYMENT,
  FLIGHT_BUY_TICKET,
  FLIGHT_RETRIVE_BOOKING,
  FLIGHT_FARE_RULES,
  FLIGHT_CONFIRMATION,
  APPLY_GLOBAL_PROMO_CODE
} from './actions.type';
import ApiService from '@/common/api.services';

const headers = {
  'Content-Type': 'application/json',
  'AFFILATE-PARTNER-TOKEN': 'UxXLIFtrJyLhcea',
};

const state = {};

const getters = {};

const actions = {
  [FLIGHT_BUY_TICKET](context, params) {
    ApiService.setHeader();

    return ApiService.post(`booking/flight`, params)
      .then((response) => {
        return response.data.response;
      })
      .catch((error) => {
        return error;
      });
  },
  [FLIGHT_BOOKING](context, params) {
    ApiService.setHeader();

    return ApiService.post(`flight`, params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  },
  [FLIGHT_FARE_CONFIRMATION](context, params) {
    ApiService.setHeader();

    return ApiService.post(`fare/confirmation`, params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  },
  [FLIGHT_MAKE_PAYMENT](context, params) {
    ApiService.setHeader();

    return ApiService.post(`fare/makePayment`, params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  [FLIGHT_RETRIVE_BOOKING](context, params) {
    ApiService.setHeader();

    return ApiService.post(`/booking/retrieve`, params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  },
  [FLIGHT_CONFIRMATION]({ commit }, props) {
    state.isLoading = true;
    return ApiService.get(props.url)
      .then(({ data: { response: res } }) => {
        state.isLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },
  [FLIGHT_FARE_RULES](context, params) {
    ApiService.setHeader();

    return ApiService.post(`/fare/rules`, params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  [APPLY_GLOBAL_PROMO_CODE](context, params) {
    ApiService.setHeader();

    return ApiService.post(`/apply-global-promocode`, params)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
